import {CompassIcon} from 'lucide-react';
import {NavLink} from 'react-router';

import {MobileNavMenu} from './mobile-nav-menu.js';
import {ThemeToggle} from './theme-toggle.js';
import {cn} from '@/lib/cn.js';

/** Primary navigation destinations. */
const NAV_ITEMS = [
  {to: '/dashboard', label: 'Dashboard'},
  {to: '/library', label: 'Library'},
  {to: '/create', label: 'Create'},
  {to: '/activity', label: 'Activity'},
  {to: '/settings', label: 'Settings'},
] as const;

/**
 * Application header with primary navigation.
 *
 * @returns The rendered header.
 */
export function SiteHeader(): React.JSX.Element {
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/85 backdrop-blur">
      <div className="mx-auto flex h-14 w-full max-w-6xl items-center gap-2 px-4 sm:gap-4">
        <NavLink
          to="/"
          className="flex shrink-0 items-center gap-2 font-semibold"
        >
          <CompassIcon className="size-5 text-primary-emphasis" />
          <span className="whitespace-nowrap">Intro Talk Finder</span>
        </NavLink>

        <nav
          aria-label="Main"
          className="ml-auto hidden min-w-0 items-center gap-0.5 sm:flex md:gap-1"
        >
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({isActive}) =>
                cn(
                  'shrink-0 rounded-md px-2 py-1.5 text-sm transition-colors md:px-3',
                  isActive
                    ? 'bg-muted font-medium text-foreground'
                    : 'text-muted-foreground hover:text-foreground',
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
          <ThemeToggle />
        </nav>

        <div className="ml-auto">
          <MobileNavMenu items={NAV_ITEMS} />
        </div>
      </div>
    </header>
  );
}
